import { IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

export const IconInstagram = (props: IconProps) => (
  <svg className={iconStyles(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.09 50.06">
    <path
      opacity=".5"
      fill="#FFF"
      d="M25.05 50.06a25 25 0 1 1 17.7-7.32 25 25 0 0 1-17.7 7.32zM25 2.12a22.91 22.91 0 1 0 16.25 6.71A22.85 22.85 0 0 0 25 2.12zM42 42z"
    />
    <path
      opacity=".5"
      fill="#FFF"
      d="M34.7 32.39a2.3 2.3 0 0 1-2.3 2.3H17.69a2.3 2.3 0 0 1-2.3-2.3v-9.82H19a6.5 6.5 0 0 0-.51 2.43 6.56 6.56 0 1 0 13.11 0 6.5 6.5 0 0 0-.48-2.46h3.58v9.82zm-13.08-9.82a4.22 4.22 0 1 1-.79 2.43 4.24 4.24 0 0 1 .79-2.46m12.11-6.76h.53v4.07h-4v-4.03zM32.4 13H17.69a4.64 4.64 0 0 0-4.63 4.63v14.76A4.64 4.64 0 0 0 17.69 37H32.4a4.64 4.64 0 0 0 4.6-4.61V17.67A4.64 4.64 0 0 0 32.4 13"
    />
  </svg>
);
